import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { validatenull } from '@/util/validate';
import { option, list } from '@/const/setting/';
import config from "../../../../package.json";
export default {
  data: function data() {
    return {
      box: false,
      form: {},
      list: list,
      option: option(this),
      version: config.version
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['isShade'])), mapState({
    showTag: function showTag(state) {
      return state.common.showTag;
    },
    showDebug: function showDebug(state) {
      return state.common.showDebug;
    },
    showLock: function showLock(state) {
      return state.common.showLock;
    },
    showColor: function showColor(state) {
      return state.common.showColor;
    },
    showFullScren: function showFullScren(state) {
      return state.common.showFullScren;
    },
    showCollapse: function showCollapse(state) {
      return state.common.showCollapse;
    },
    showSearch: function showSearch(state) {
      return state.common.showSearch;
    },
    showMenu: function showMenu(state) {
      return state.common.showMenu;
    },
    showTheme: function showTheme(state) {
      return state.common.showTheme;
    }
  })),
  created: function created() {
    var _this = this;
    setTimeout(function () {
      _this.init();
    }, 0);
  },
  methods: {
    close: function close() {
      this.box = false;
      this.$store.commit('SET_SHADE', false);
    },
    set: function set(key) {
      var ele = this.find(key);
      this.$store.commit(ele.commit, eval(this.form[ele.key]));
    },
    find: function find(key) {
      return this.list.filter(function (ele) {
        return ele.key === key;
      })[0];
    },
    init: function init() {
      var _this2 = this;
      this.list.forEach(function (ele) {
        _this2.form[ele.key] = validatenull(_this2[ele.key]) ? 'true' : _this2[ele.key] + '';
        _this2.set(ele.key);
      });
    },
    open: function open() {
      this.box = true;
      this.$store.commit('SET_SHADE', true);
    }
  }
};